module.exports = __webpack_public_path__ + "media/images/svg/clients/7-c43dab32b28778fd2080245a256c3d34.svg";